import React from "react";

// Styles
import "./Team.scss";

// Founder image
import founderImage from "../../images/about/viewgener-founder-leadership.png";
import leadershipGlobe from "../../images/about/viewgener-leadership-globe.png";
import officeImage from "../../images/about/viewgener-leadership-office.png";

const Team = () => {
  return (
    <main className="team" id="team">

      {/* Decorative background */}
      <div className="leadership-bg-glow leadership-bg-glow-left"></div>
      <div className="leadership-bg-glow leadership-bg-glow-right"></div>
      <div className="leadership-world">
  <img src={leadershipGlobe} alt="" />
</div>

      {/* Section heading */}
      <div className="leadership-heading">
        <h1>LEADERSHIP</h1>

        <p>
          Visionary leadership shaping businesses, people and opportunities
          for generations.
        </p>
      </div>

      {/* Founder section */}
      <div className="leadership-founder">
        <div className="leadership-office">
  <img src={officeImage} alt="" />
</div>

        {/* LEFT SIDE */}
        <div className="founder-image">

          <div className="founder-circle"></div>

          <div className="founder-sidewords">
            <span>PEOPLE</span>
            <span>IDEAS</span>
            <span>OPPORTUNITIES</span>
            <span>EXPERIENCES</span>

            <div className="sidewords-line"></div>
          </div>

          <img
            src={founderImage}
            alt="Byron René Valencia - Founder and CEO of ViewGeneR"
          />

          <div className="founder-bottom-glow"></div>
        </div>

        {/* RIGHT SIDE */}
        <div className="founder-content">

          <h2>
            BYRON RENÉ
            <br />
            VALENCIA
          </h2>

          <h3>FOUNDER &amp; CEO · VIEWGENER</h3>

          <div className="founder-line"></div>

          <p className="founder-intro">
            Entrepreneur, strategist and global vision builder.
          </p>

          <p className="founder-text">
            With a deep passion for people, innovation and sustainable growth,
            I founded ViewGeneR to create opportunities, connect talent and
            develop industries that generate a positive impact across
            generations.
          </p>

          <p className="founder-text founder-purpose">
            My purpose is to build a global ecosystem where{" "}
            <strong>ideas, people and businesses</strong> thrive together.
          </p>

          <div className="founder-values">

            <div className="founder-value">
              <span className="value-icon">◎</span>
              <span>
                GLOBAL
                <br />
                VISION
              </span>
            </div>

            <div className="founder-value">
              <span className="value-icon">♙</span>
              <span>
                PEOPLE
                <br />
                DEVELOPMENT
              </span>
            </div>

            <div className="founder-value">
              <span className="value-icon">↗</span>
              <span>
                SUSTAINABLE
                <br />
                GROWTH
              </span>
            </div>

            <div className="founder-value">
              <span className="value-icon">◇</span>
              <span>
                LASTING
                <br />
                IMPACT
              </span>
            </div>

          </div>

          <blockquote className="founder-quote">
            “A greater tomorrow is built today,
            <br />
            through people, ideas and action.”
          </blockquote>

          <div className="quote-line"></div>

        </div>
      </div>
    </main>
  );
};

export default Team;